import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
     CBadge
} from '@coreui/react'
import CIcon from '@coreui/icons-react';
import Cookies from 'js-cookie';

import { signout } from '../../../helpers/auth';
import { API_SUPPORT_EXIT, SUBSCRIBER_MY_ACCOUNT_PATH } from '../../../constants';
import {
     Dropdown,
     DropdownItem,
     DropdownMenu,
     DropdownToggle,
} from '../../../components/general/dropdown';
import { callTokenApi } from '../../../apiCaller';
import { getSupportRedirectChannelId } from '../../../helpers/cms/support';
import { TOURSTEPS } from '../TheTour';
import CImg from '../../../components/migration/CImg';
import {Link, useLocation} from 'react-router-dom';

const SubscriberAccountDropdown = () => {
     const user = useSelector(state => state.theme.user);
     const { showTour, stepTour } = useSelector(state => state.subscriber.tour);
     const isCustomerSupportLoginAs = useSelector(state => state.subscriber.isCustomerSupportLoginAs);
     const numberOfCommentsTickets = useSelector(state => state.subscriber.numberOfCommentsTickets);
     const [isExiting, setIsExiting] = useState(false);
     const location = useLocation();
     const path = location.pathname;
     const accountPathPrefix = '/my-account/';
     const slug = path.startsWith(accountPathPrefix) ? path.slice(accountPathPrefix.length).split('/')[0] : '';

     const handleExit = () => {
          setIsExiting(true);

          callTokenApi(`${API_SUPPORT_EXIT}?redirectChannelId=${getSupportRedirectChannelId()}`, 'GET')
               .then(response => {
                    setIsExiting(false);
                    const { token, expirationDate } = response.data;

                    if (response.status === 200) {
                         // Set token of CS to cookie and redirect to home
                         let tokenOptions = { expires: new Date(expirationDate) };

                         if (window.location.hostname !== 'localhost') {
                              tokenOptions.domain = 'listenlayer.com';
                         }

                         Cookies.set('token', token, tokenOptions);
                         window.location.replace('/accounts');
                    } else {
                         signout(true);
                    }
               })
     }
     
     return (
          <Dropdown
               isHeaderDropdown
               inNav
               className={`header-nav-items user-nav-item${showTour && stepTour === TOURSTEPS.personalLogin.orderNumber ? ' highlight-item' : ''}`}
               direction="down"
               forceOpen={showTour && stepTour === TOURSTEPS.personalLogin.orderNumber}
          >
               <DropdownToggle
                    className="header-nav-link"
                    caret={false}
               >
                    <div className="avatar avatar1" style={{width: '36px', height: '36px'}}>
                         <CImg
                              src={user.avatar && user.avatar !== 'false' ? user.avatar : '/user-default-avatar.png'}
                              className="avatar-img"
                              alt="avatar"
                         />
                         <img src="/assets/icons/Shapeavatar.svg" alt="shape-avatar" className="shape-avatar-icon"></img>

                    </div>
               </DropdownToggle>
               <DropdownMenu
                    className="pt-0 account-dropdown setting-dropdown subcrib"
                    placement="bottom-end"
                    style={{ '--cui-dropdown-font-size' : '.9rem'}}
               >
                    <CIcon icon="arrow-account" className="arrow-account arrow-setting" />
                    <DropdownItem
                         header
                         tag="div"
                    >
                         <span>My Account</span>
                         <p className="account-user-email m-0">{user ? user.email : ''}</p>
                    </DropdownItem>
                    {
                         isCustomerSupportLoginAs ? (
                              <DropdownItem className="sign-out text-danger" onClick={handleExit} disabled={isExiting} clickDoesNotClose={true}>
                                   <span>
                                        EXIT TO CUSTOMER SUPPORT CMS{isExiting && <span className="dots-waiting"></span>}
                                   </span>
                              </DropdownItem>
                         ) : (
                              <>
                                   <DropdownItem as={Link} to={SUBSCRIBER_MY_ACCOUNT_PATH.PROFILE} className={slug && slug === 'profile' && 'active'}>
                                        My Profile
                                   </DropdownItem>
                                   <DropdownItem as={Link} to={SUBSCRIBER_MY_ACCOUNT_PATH.EMAIL_NOTIFICATIONS} className={slug && slug === 'email-notifications' && 'active'}>
                                        Email Notifications
                                   </DropdownItem>
                                   {/* <DropdownItem className="affiliate" to={SUBSCRIBER_MY_ACCOUNT_PATH.AFFILIATE}>
                                        Affiliate
                                        <CBadge className="label-share">SHARE & EARN</CBadge>
                                   </DropdownItem> */}
                                   <DropdownItem as={Link} className={`my-ticket${slug && slug === 'support-tickets' && ' active'}`} to={SUBSCRIBER_MY_ACCOUNT_PATH.SUPPORT_TICKETS}>
                                        My Tickets
                                        {numberOfCommentsTickets > 0 && <CBadge color="info" style={{ lineHeight: '18px', padding: '0 5px', height: '18px' }} className="mfs-auto">{numberOfCommentsTickets}</CBadge>}
                                   </DropdownItem>
                              </>
                         )
                    }
                    <DropdownItem className="sign-out text-danger" onClick={signout}>
                         SIGN OUT
                    </DropdownItem>
               </DropdownMenu>
          </Dropdown>
     )
}

export default React.memo(SubscriberAccountDropdown)
